import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

class SlidesModel extends AbstractSessionModel {
  @Observable()
  public currentActiveSliderTransitions: Map<string, any> = new Map();

  constructor() {
    super();

    super.initFields();
  }

  @Action()
  public setSliderTransition(
    sliderId: string,
    transition: {
      position: any;
    }
  ) {
    this.currentActiveSliderTransitions.set(sliderId, transition);
  }

  @Action()
  public removeSliderTransition(sliderId: string) {
    this.currentActiveSliderTransitions.delete(sliderId);
  }

  getSessionKey(): string {
    return 'SlidesModel';
  }
}

export default new SlidesModel();
